import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { trigger, state, style, animate, transition } from '@angular/animations';
import { loadingFade, modal, alert } from '../../animacoes';


import { UsuarioService } from '../services/usuario.service';
import { UsuarioUnidadeService } from '../services/usuario-unidade.service';
import { UnidadeService } from '../services/unidade.service';
import { ProfissionalService } from '../services/profissional.service';
import * as Datepicker from 'js-datepicker'
import * as moment from 'moment'
import Swal from 'sweetalert2';

@Component({
	selector: 'app-usuarios-edit',
	templateUrl: './usuarios-edit.component.html',
	styleUrls: ['./usuarios-edit.component.css'],
	animations: [loadingFade, modal, alert]
})
export class UsuariosEditComponent implements OnInit {
	public formUsuario: FormGroup;
	public loading;
	public submitting = false;

	public usuario_id = null;
	public data_nasc_dp;
	public usuario_situacao;
	
	public perfis = [];
	public clientes = [];
	public unidades = [];
	public usuario_unidades = [];
	public profissionais;

	// alert
	public msg_alerta = '';
	public class_alerta = '';
	public flag_alerta = 'hidden';
	public exibeSubmit = true;
	public carregando_unidade = false;

	//filtro
	public cliente_id___cliente = null;
	public unidade_id___unidade = null;
	public usuario_login___login = null;
	public usuario_nome___usuario = null;
	public perfil_id___perfil = null;
	public usuario_status___status = null;

	constructor(private route: ActivatedRoute,
				private fb: FormBuilder,
				private router: Router,
				private usuarioSvc: UsuarioService,
				private unidadeSvc: UnidadeService,
				private usuarioUnidadeSvc: UsuarioUnidadeService,
				private profissionalSvc: ProfissionalService
				) {}

	ngOnInit() {
		this.criaForm();
		this.preenchePerfil();

		this.loading = true;

       	

		this.route.params.subscribe( params => {
			if (params.id) {

				var splitFiltro = params.id.split("?");

				if(splitFiltro[1] !== undefined){
				  
				  var splitfiltro = splitFiltro[1].split("&");
				  for (let f in splitfiltro) {
		
					var loSplitValor = splitfiltro[f].split("=");
		
					switch(loSplitValor[0]) { 
					  case "cliente_id___cliente": { 
						 this.cliente_id___cliente = loSplitValor[1];
						 break; 
					  } 
					  case "unidade_id___unidade": { 
						this.unidade_id___unidade = loSplitValor[1];
						 break; 
					  } 
					  case "usuario_login___login": { 
						this.usuario_login___login = loSplitValor[1];
						 break; 
					  } 
					  case "usuario_nome___usuario": { 
						this.usuario_nome___usuario = loSplitValor[1];
						 break; 
					  }      
					  case "perfil_id___perfil": { 
						this.perfil_id___perfil = loSplitValor[1];
						 break; 
					  }     
					  case "usuario_status___status": { 
						this.usuario_status___status = loSplitValor[1];
						 break; 
					  }  					                                                         
				   }
		
				  }
		
		
				}  	
				
				this.usuario_id = params.id;
				// pega dados a partir do id
				this.usuarioSvc.getUsuario(params.id).then((data: any) => {
					let data_nasc = null;
					if (moment(data.usuario_data_nascimento).isValid()) {
						let moment_date = moment(data.usuario_data_nascimento, 'YYYY-MM-DD');
						data_nasc = moment_date.format('DD/MM/YYYY');
						//this.data_nasc_dp.setDate(moment_date.toDate());
					}
					
					this.usuarioUnidadeSvc.getUsuarioUnidades(params.id).then((dados: any[]) =>{
						for(let unidade of dados){
							this.usuario_unidades.push(unidade.unidade_id);
						}
						this.pegaProfissionais(this.usuario_unidades);
						this.preencheForm({
							usuario_id: data.usuario_id,
							usuario_nome: data.usuario_nome,
							usuario_email: data.usuario_email,
							usuario_cpf: data.usuario_cpf,
							usuario_rg: data.usuario_rg,
							usuario_data_nascimento: data_nasc,
							usuario_login: data.usuario_login,
							usuario_senha: '',
							confirmar_senha: '',
							usuario_perfil: data.usuario_perfil,
							usuario_situacao: data.usuario_situacao,
							profissional_id: data.profissional_id,
							unidades: this.usuario_unidades
						});
					}).catch((err) => {
						console.log(err);
					});
					this.loading = false;
				});

				if(params.visualizar == "ver"){
					this.formUsuario.controls['usuario_nome'].disable();
					this.formUsuario.controls['usuario_email'].disable();
					this.formUsuario.controls['usuario_cpf'].disable();
					this.formUsuario.controls['usuario_rg'].disable();
					this.formUsuario.controls['usuario_data_nascimento'].disable();
					this.formUsuario.controls['usuario_perfil'].disable();
					this.formUsuario.controls['usuario_login'].disable();
					this.formUsuario.controls['usuario_senha'].disable();
					this.formUsuario.controls['confirmar_senha'].disable();
					this.formUsuario.controls['unidades'].disable();
					this.formUsuario.controls['profissional_id'].disable();
					this.formUsuario.controls['usuario_situacao'].disable();
					this.formUsuario.controls['usuario_situacao'].disable();
					this.exibeSubmit = false;
				}else{
					this.data_nasc_dp = Datepicker('#usuario_data_nascimento', {
						customMonths: moment.months(),
						customDays: moment.weekdaysShort(),
						overlayPlaceholder: 'Preencha o ano',
						overlayButton: 'Enviar',
						formatter: (element, date) => {
							let formatted = moment(date).format('DD/MM/YYYY');
							this.formUsuario.get("usuario_data_nascimento").setValue(formatted);
						}
					});					
				}


			}
			else {

				this.data_nasc_dp = Datepicker('#usuario_data_nascimento', {
					customMonths: moment.months(),
					customDays: moment.weekdaysShort(),
					overlayPlaceholder: 'Preencha o ano',
					overlayButton: 'Enviar',
					formatter: (element, date) => {
						let formatted = moment(date).format('DD/MM/YYYY');
						this.formUsuario.get("usuario_data_nascimento").setValue(formatted);
					}
				});

				this.formUsuario.get('usuario_senha').setValidators(Validators.required);
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.pegaUnidades();
		this.formUsuario = this.fb.group({
			usuario_id: null,
			usuario_nome: ['', Validators.required],
			usuario_email: [''],
			usuario_cpf: [''],
			usuario_rg: '',
			usuario_data_nascimento: [null, [Validators.required, this.isValidDate]],
			usuario_login: ['', Validators.required],
			usuario_senha: '',
			confirmar_senha: '',
			usuario_perfil: [null, Validators.required],
			usuario_situacao: false,
			unidades: [null, Validators.required],
			profissional_id: null,
		});
		moment.locale('pt-Br');

	}
	
	preencheForm(dados) {
		this.formUsuario.setValue(dados);
	}

	preenchePerfil() {
		this.usuarioSvc.getPerfis().then((data: any[]) => {
			this.perfis = data;
		});
	}

	enviaUsuario() { // todo: verificar se login existe
		if (this.formUsuario.valid) {
			this.submitting = true;

			let toSend = this.formUsuario.value;
			if (toSend.usuario_data_nascimento)
				toSend.usuario_data_nascimento = moment(toSend.usuario_data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD');


			if(toSend.usuario_senha != toSend.confirmar_senha){
				Swal.fire({
					type:'error',
					title:'Senha e confirmação de senha não coincidem',					       
				});
				this.submitting = false;
				return;
			}

			if (this.usuario_id === null) { // criar
				this.usuarioSvc.criaUsuario(toSend).then((data: any) => {
					//console.log('resp', data);
					Swal.fire({
						type:'success',
						title:'Usuário cadastrado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/usuarios']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type:'error',
						title:'Este Login já está em uso!',
					});
				});
			}
			else { // editar
				this.usuarioSvc.editaUsuario(toSend).then((data) => {
					//console.log('resp', data);
					Swal.fire({
						type:'success',
						title:'Usuário alterado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/usuarios']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type:'error',
						title:'Este Login já está em uso!',
					});
				});
			}
		}
		else{
			for( let field in this.formUsuario.controls){
				let campo = this.formUsuario.get(field);
				campo.markAsTouched();
			}
			Swal.fire({
				type:'error',
				title:'Atenção!',
				text:'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formUsuario.get(nome);
		return input.touched && input.invalid;
	}
	
	pegaUnidades(){
		this.carregando_unidade = true;
		this.unidadeSvc.getUnidadesAtivas().then((data: any[]) => {

			this.unidades = data;
			for(let index in this.unidades){
				this.unidades[index].cliente_nome = this.unidades[index].cliente.cliente_nome;
			}
			this.carregando_unidade = false;

		}).catch((err) => {
			console.log(err);
		});
	}

	onChangeUnidades(e){
		let aux = [];
		for(let unidade of e){
			aux.push(unidade.unidade_id);
		}
		this.profissionalSvc.getProfissionaisByUnidades({'unidades': aux}).then((data: any) => {
			this.profissionais = data;
		});
	}
	pegaProfissionais(unidades){
		this.profissionalSvc.getProfissionaisByUnidades({'unidades': unidades}).then((data: any) => {
			this.profissionais = data;
		});
	}

	mostraMsg(msg, classe) {
		this.msg_alerta = msg;
		this.class_alerta = classe;
		this.flag_alerta = 'shown';
		setTimeout(() => this.flag_alerta = 'hidden', 10);
	}

	isValidDate(c: FormControl): ValidationErrors {
		let result: ValidationErrors = null;
		const isValid = moment(c.value, 'DD/MM/YYYY').isValid();
		if (!isValid) {
			result = { invalidDate: 'Invalid date' };
		}
		return result;
	  }

	  onClickVoltar(){

		let params = 'cliente_id___cliente=' + this.cliente_id___cliente;
		params += "&unidade_id___unidade=" + this.unidade_id___unidade;
		params += "&usuario_login___login=" + this.usuario_login___login;
		params += "&usuario_nome___usuario=" + this.usuario_nome___usuario;
		params += "&perfil_id___perfil=" + this.perfil_id___perfil;
		params += "&usuario_status___status=" + this.usuario_status___status;		
	
		//this.router.navigate(['/home/usuariosfiltro/' + params]);

		this.router.navigate(['/home/usuarios'])
	
	  }	  

	
}
